import React from "react";
import "./safetyApp.scss";

import SafetyAppSEO from "../Components/SEO/SafetyAppSEO";
import { SafetyAppHero } from "../Components/SafetyApp/SafetyAppHero";
import { NavBar } from "../Components/Nav/NavBar";
import { TopFeatures } from "../Components/SafetyApp/TopFeatures";
import { InfoCards } from "../Components/SafetyApp/InfoCards";
import { ReassuranceSection } from "../Components/SafetyApp/ReassuranceSection";
import { ExecManagerEmployee } from "../Components/SafetyApp/ExecManagerEmployee";
import { TabFeatures } from "../Components/SafetyApp/TabFeatures";
import { StatsSection } from "../Components/SafetyApp/StatsSection";
import { Industries } from "../Components/SafetyApp/Industries";
import { NewHero } from "../Components/SafetyApp/NewHero";

export function SafetyAppPage(props) {
  return (
    <>
      <SafetyAppSEO />
      {/* <SafetyAppHero /> */}
      <NewHero />
      <StatsSection />
      <Industries />
      <ExecManagerEmployee />
      <TabFeatures />
      {/* <TopFeatures /> */}
      {/* <InfoCards /> */}

      <ReassuranceSection />
    </>
  );
}
